export const environment = {
  "subscriptionKey": "606857ca0fc2483083bc16f4000cfa71",
  "apiUrlAPIM" : "https://apim-dev-internal.azure.chevron.com/strategic-internal/wellview-library-api/v2",
  "apiUrlAzure" : "https://wvsaas-wvapi-dev-cvx.azurewebsites.net",
  "pelotonProdHost": "https://wvsaas-wvapi-prod-cvx.azurewebsites.net",
  "pelotonTestHost": "https://wvsaas-wvapi-dev-cvx.azurewebsites.net",
  "baseUrl": "https://wvtoolsapp-dev.azure.chevron.com",
  "clientId": "cc610a99-f02c-4ef4-93dd-f029b155a059",
  "scopes": ["cc610a99-f02c-4ef4-93dd-f029b155a059/user_impersonation"],
  "pelotonRegion": "v21na",
  "pelotonProductId": "5355ff9c-44bd-4a40-8911-1c9b5c63c1ff"
}